@if (asset(); as asset) {
  <div class="card">
    <div class="info">
      @if (asset.images && asset.images.length) {
        <img [imageSource]="{
            guid: asset.images[0],
            transparent: false,
            type: LegacyImageProcessorTypes.CarouselItem,
          }"
          [alt]="asset.year + ' ' + asset.make + ' ' + asset.model"
          data-testid="image"
        />
      } @else {
        <img [src]="defaultImage()" alt="No photo available" i18n-alt="@@general.no-image.alt" data-testid="image" />
      }
      <div class="details" colorScheme="assetCard.main">
        <div class="details--name">{{asset.year}} {{asset.make}} {{asset.model}}</div>
        <div class="details--price" colorScheme="assetCard.price">{{asset.list_price && !asset.is_list_price_hidden ? (asset | assetPrice : currencyCode()) : contactForPricing}}</div>
      </div>
    </div>
    <div class="actions">
      <app-icon-button
        class="close"
        icon-btn-outlined
        icon-btn-small
        icon-btn-icon-xsmall
        matIcon="close"
        (click)="clearClicked.emit()"
        aria-label="Remove"
        i18n-aria-label="@@comparison-card.remove-button.aria-label"
      />
    </div>
  </div>
}
